import {ChangeDetectorRef, Component, Input} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {interval} from "rxjs";
import * as Highcharts from 'highcharts';
import {retryWithBackoff} from "../../../../libs/rxjs/retryWithBackoff";
import {map, startWith, switchMap} from "rxjs/operators";
import {IAppStatic} from "../../../interfaces";
import {timeout} from "../../../decorators/timeout";
import {TranslocoService} from "@ngneat/transloco";
import {fadeTransition} from 'libs/basicTransition';
import {DEFAULT_SERVER_PING_POLL} from "../../../common";
import {Compbaser} from "../../../components/compbaser";
import {StoreSelectorsService} from "../../../services";
import * as _ from 'lodash';
import {Color, ScaleType} from '@swimlane/ngx-charts';
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-server-avg',
    templateUrl: './server-avg.component.html',
    styleUrls: ['./server-avg.component.scss'],
    animations: [fadeTransition]
})
export class ServerAvgComponent extends Compbaser {
    chartData: any[];
    chartDataServers = [];

    // options
    legend = false;
    showLabels = true;
    animations = true;
    xAxis = true;
    yAxis = true;
    showYAxisLabel = true;
    showXAxisLabel = false;
    xAxisLabel = '';
    yAxisLabel = '';
    timeline = true;

    colorScheme: Color = {
        name: 'Customer Usage',
        selectable: true,
        group: ScaleType.Ordinal,
        domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
    };

    _options;
    _chart: any;
    _ready = false;
    Highcharts: typeof Highcharts = Highcharts;
    chartOptions: Highcharts.Options;
    private appSettings: IAppStatic;

    @Input() showServers = false;


    constructor(private storeSelector: StoreSelectorsService,
                private _http: HttpClient,
                private toastr: ToastrService,
                private cd: ChangeDetectorRef,
                private translocoService: TranslocoService) {
        super();
        this.cod(
            storeSelector.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                })
        );
        this.initGrapha();
    }

    logChartInstance(chart: Highcharts.Chart) {
        this._chart = chart;
    }

    chartCallback = (chart) => {
        setTimeout(() => {
            if (!chart || !chart.callback || chart.callback.length == 0) return;
            chart.reflow();
        }, 1);
    };

    @timeout(1000)
    initGrapha() {
        this._options = {
            chart: {
                renderTo: 'chartContainer',
                reflow: true,
                type: 'spline',
                borderColor: 'black',
                borderWidth: 0
            },
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: '100%'
                    },
                    chartOptions: {
                        legend: {
                            align: 'center',
                            verticalAlign: 'bottom',
                            layout: 'horizontal'
                        },
                        yAxis: {
                            labels: {
                                align: 'left',
                                x: 0,
                                y: -5
                            },
                            title: {
                                text: null
                            }
                        },
                        subtitle: {
                            text: null
                        },
                        credits: {
                            enabled: false
                        }
                    }
                }]
            },
            title: {
                text: ''
            },

            xAxis: {
                labels: {
                    enabled: false
                },
                categories: []
            },
            credits: {
                enabled: false
            },
            yAxis: [{
                min: 0,
                title: {
                    text: this.translocoService.translate('general.cloudNetRes', {}, this.translocoService.getActiveLang())
                }
            }, {
                title: {
                    text: this.translocoService.translate('general.measuredMs', {}, this.translocoService.getActiveLang())
                },
                opposite: true
            }],
            legend: {
                enabled: false,
                shadow: false
            },
            tooltip: {
                enabled: false
            },
            // tooltip: {
            //     headerFormat: `<span style="color: {series.color} !important">{point.key}</span><table style="color: white">`,
            //     pointFormat: `<tr><td style="color:  {series.color};padding:0">{series.name}: </td><td style="padding:0; color:  {series.color}"><b><span style="color:  {series.color}">{point.y:.1f} </span></b></td></tr>`,
            //     footerFormat: '</table>',
            //     shared: true,
            //     useHTML: true
            // },
            // tooltip: {
            //     headerFormat: `<span style="color: {series.color} !important">{point.key}</span><table style="color: white">`,
            //     pointFormat: `<tr><td style="color: var(--text-color1);padding:0">{series.name}: </td><td style="padding:0; color: var(--text-color1)"><b><span style="color: var(--text-color1)">{point.y:.1f} </span></b></td></tr>`,
            //     footerFormat: '</table>',
            //     shared: true,
            //     useHTML: true
            // },
            plotOptions: {
                column: {
                    grouping: false,
                    shadow: false,
                    borderWidth: 0
                }
            },
            series: [{data: [0]}]
        };
        this.chartOptions = this._options;

        this.yAxisLabel = this.translocoService.translate('general.cloudNetRes', {}, this.translocoService.getActiveLang());
        this.chartData = [{
            "name": this.translocoService.translate('general.cloudNetRes', {}, this.translocoService.getActiveLang()),
            "series": [
                {
                    "name": "A",
                    "value": 0
                },
                {
                    "name": "B",
                    "value": 100
                },
                {
                    "name": "C",
                    "value": 500
                }
            ]
        }];

        setTimeout(() => {
            this._ready = true;
            this.serverStatus();
        }, 2);
    }

    public serverStatus() {
        this.cod(
            // interval(Lib.DevMode() ? 2000 : 3000)
            interval(DEFAULT_SERVER_PING_POLL)
                .pipe(
                    startWith(0),
                    switchMap(() =>
                        this._http.get(`${this.appSettings.globalService}/msPingServersGuest`).pipe(
                            retryWithBackoff(`${this.appSettings.globalService}/msPingServersGuest`, this.storeSelector, this.toastr),
                            map((result: any) => {
                                this.chartDataServers = [];
                                this._ready = true;
                                this.cd.markForCheck();
                                let avg = 0;
                                let t = 0;
                                _.forEach(result, (stats, server) => {
                                    stats = stats / 100 * _.random(10, 20);
                                    this.chartDataServers.push({name: `server ${t + 1}`, value: stats});
                                    t++;
                                    avg = Number(stats) + avg;
                                });
                                if (!this._chart)
                                    return 0;
                                return avg / t;
                            })
                        )
                    ))
                .subscribe((value: any) => {
                    if (!this._chart)
                        return;
                    const seriesA = this._chart.series[0];
                    const shift = seriesA.data.length > 20;
                    this._chart.series[0].addPoint(value, true, shift);
                }, error => {
                    console.log('error loading serverStatus ' + error);
                })
        );
    }

    onSelect(e) {

    }
}
